/**
 * SaveLoadDialog - Wrapper component for save/load menu using Dialog
 */

import type { Component, ReactNode } from 'react';
import Dialog from './Dialog';

// React is available globally from CDN
const React = (window as any).React;
const ReactComponent = React.Component;

interface SaveLoadDialogProps {
    onClose: () => void;
    children: ReactNode;
}

class SaveLoadDialog extends ReactComponent<SaveLoadDialogProps> {
    render(): ReactNode {
        const DialogComponent = (window as any).Dialog;
        if (!DialogComponent) {
            return null;
        }

        return React.createElement(DialogComponent, {
            title: 'Game Saves',
            onClose: this.props.onClose,
            closeOnBackdropClick: true, // No action buttons, so close on backdrop click
            maxWidth: '720px'
        }, this.props.children);
    }
}

(window as any).SaveLoadDialog = SaveLoadDialog;
export default SaveLoadDialog;
